import React from "react";
import styled from "styled-components";
import {TypeTitle, NameTitle, TextDescription, IconClass} from "../../styles/Products";
import ShowMore from "../ShowMore";
import Color from "../../assets/Colors";
import {IconTypeCourse} from "../IconType";

export default function OfferProduct({itemData}) {
   if (!itemData.data[0]) return false;
   return (
      <OfferComponent>
         <ImageOffer>
            <img src={`http://domecqapi.trebolbit.com/${itemData.data[0].pathImageMobile}`} alt={itemData.data[0].courseName} />
         </ImageOffer>
         <InfoBox>
            <IconClass>
               <IconTypeCourse type={itemData.type === "Courses" ? itemData.data[0].idCourseType : "facilitador"} />
            </IconClass>
            {/* <IconTypeCourse type={itemData.type} /> */}

            <TitleContainer>
               {itemData.name === "" ? (
                  <TypeTitle className="principal" color={Color.primary}>
                     {itemData.data[0].courseType || "  "}
                  </TypeTitle>
               ) : (
                  <TypeTitle className="secondary" color={itemData.data[0].courseType === "" ? "transparent" : ""}>
                     {itemData.data[0].courseType || ""}
                  </TypeTitle>
               )}

               <NameTitle className={!itemData.name ? "none" : ""} color={itemData.name === "" ? "transparent" : ""}>
                  {itemData.data[0].courseName || ""}
               </NameTitle>
            </TitleContainer>
            <DescriptionContainer>
               <TextDescription>{itemData.data[0].shortDescription}</TextDescription>
            </DescriptionContainer>
            <ShowMore
               type={itemData.type === "Courses" ? itemData.data[0].idCourseType : itemData.type}
               url={itemData.path}
               id={itemData.idReference}
            />
         </InfoBox>
      </OfferComponent>
   );
}

const OfferComponent = styled.div`
   width: 49.5%;
   display: flex;
   justify-content: center;
   flex-direction: column;
   align-items: center;
   position: relative;
   margin-bottom: 2em;

   &:nth-child(odd) {
      margin-right: 1%;
   }

   @media screen and (max-width: 600px) {
      width: 100%;
   }

   @media screen and (max-width: 500px) {
      &:nth-child(odd),
      &:nth-child(even) {
         margin: 0;
      }
   }
`;
const ImageOffer = styled.div`
   width: 100%;
   height: 670px;
   overflow: hidden;

   & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
   }
   @media screen and (max-width: 1600px) {
      height: 500px;
   }

   @media screen and (max-width: 800px) {
      height: 300px;
   }

   @media screen and (max-width: 500px) {
      height: 350px;
   }
`;

const InfoBox = styled.div`
   width: 95%;
   padding: 1.5em 1em;
   margin-top: -4em;
   background-color: white;
   z-index: 1000;

   @media screen and (max-width: 1600px) {
      padding: 1.5em 0.8em;
   }
   @media screen and (max-width: 1400px) {
      padding: 0.5em 0.6em;
   }
   @media screen and (max-width: 500px) {
      width: 98.5%;
      padding: 1em 0.4em;
   }
`;

const DescriptionContainer = styled.div``;
const TitleContainer = styled.div`
   margin-bottom: 1em;
   margin-top: 15px;
`;
